// extracted by mini-css-extract-plugin
export default {"container":"MatchDetailTab-module__container___Js7gx","overallScore":"MatchDetailTab-module__overallScore___QP9Us"};